<template>
  <div>
    <div class="page-welfare-wrap">
      <section class="section-welfare">
        <div class="figure figure--welfare">
          <div class="figure-inner">
            <div class="figure-hd">
              <div class="figure-infos">
                <div class="figure-infos-user">
                  <img src="@/assets/img/index/icon-switch.png" alt="" />
                </div>
                <div class="figure-infos-desc">限时活动</div>
              </div>
              <p class="figure-desc">周年庆活动更多福利持续派发中！</p>
            </div>
            <div class="figure-bd">
              <div class="figure">
                <img src="@/assets/img/index/welfare.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="button-welfare" @click="goLink('/home')">
        领取更多福利
      </div>
    </div>
  </div>
</template>

<script>
import { pgvEventReport } from '@/libs/tcss-report';
export default {
  name: 'Entry',
  components: {},
  props: {},

  data() {
    return {};
  },
  mounted() {
    pgvEventReport('anniversary.activity.page.entry');
  },
  methods: {
    // 领取更多
    goLink(path) {
      pgvEventReport('anniversary.activity.entry.getMoreBtn');
      this.$router.push({
        path
      });
    }
  }
};
</script>
<style lang="scss">
@import '../assets/css/pages/welfare.css';
</style>
